<div class="dialog">
  <mat-icon class="close pointer" (click)="cancel()">close</mat-icon>
  <mat-icon class="warning-icon secondary-color">error_outline</mat-icon>
  <p class="bigger align-center" [innerHTML]="text.header || 'weet je het zeker?'">
  </p>
  <small [innerHTML]="text.body"></small>
  <div>
    <button class="block float-left btn arrow-left" (click)="cancel()">{{text.cancel || 'Annuleer'}}</button>
    <button class="block float-right btn inverted" [ngClass]="getConfirmButtonClass(text.level)"
            style="margin-bottom:14px;" (click)="ok()">{{text.ok || 'ik weet het zeker'}}
    </button>
    <div class="clearFix"></div>
  </div>
</div>
